import styled from "@emotion/styled";

export const HeaderItem = styled.div`
margin: 0 5px;
cursor: pointer;
color: "#03406C";
font-weight: 500;
font-size: 18px;
padding: 8px 12px;
border-radius: 14px;
background-color: transparent;
&:hover{
background-color: #03406C;
color: #FFFFFF;
}

  @media (max-width: 1024px) {
    font-size: 16px;
    padding: 6px 10px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 5px 8px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    padding: 4px 6px;
    margin: 0 3px;
  }

`;